import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth-guard.service';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { LayoutComponent } from './pages/layout/layout.component';
import { LoginComponent } from './pages/login/login.component';

const routes: Routes = [
  { path: '', redirectTo: 'login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent },
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent },
      { path: 'header-pages', loadChildren: () => import('./pages/header-pages/header-pages.module').then(m => m.HeaderPagesModule) },

      { path: 'accession', loadChildren: () => import('./pages/accession/accession.module').then(m => m.AccessionModule) },
      { path: 'work-bench', canActivate: [AuthGuard], loadChildren: () => import('./pages/work-bench/work-bench.module').then(m => m.WorkBenchModule) },
      { path: 'lab-admin', canActivate: [AuthGuard], loadChildren: () => import('./pages/lab-admin/lab-admin.module').then(m => m.LabAdminModule) },
      { path: 'data-entry-review', loadChildren: () => import('./pages/data-entry-review/data-entry-review.module').then(m => m.DataEntryReviewModule) },
      { path: 'client-admin', canActivate: [AuthGuard], loadChildren: () => import('./pages/client-admin/client-admin.module').then(m => m.ClientAdminModule) },
      { path: 'billing-data-review', loadChildren: () => import('./pages/billing-data-review/billing-data-review.module').then(m => m.BillingDataReviewModule) },
      { path: 'billing-admin', canActivate: [AuthGuard], loadChildren: () => import('./pages/billing-admin/billing-admin.module').then(m => m.BillingAdminModule) },
      { path: 'regulatory', loadChildren: () => import('./pages/regulatory/regulatory.module').then(m => m.RegulatoryModule) },
      { path: 'faxes', loadChildren: () => import('./pages/faxes/faxes.module').then(m => m.FaxesModule) },
      { path: 'results', loadChildren: () => import('./pages/results/results.module').then(m => m.ResultsModule) },
      { path: 'interfaces', loadChildren: () => import('./pages/interfaces/interfaces.module').then(m => m.InterfacesModule) },
      { path: 'miscellaneous', loadChildren: () => import('./pages/miscellaneous/miscellaneous.module').then(m => m.MiscellaneousModule) },
      { path: 'analytics', loadChildren: () => import('./pages/analytics/analytics.module').then(m => m.AnalyticsModule) },
      { path: 'validations', loadChildren: () => import('./pages/validation/validation.module').then(m => m.ValidationModule) },
      { path: 'batch-processes', loadChildren: () => import('./pages/batch-processes/batch-processes.module').then(m => m.BatchProcessesModule)},
      { path: 'client-services', loadChildren: () => import('./pages/client-services/client-services.module').then(m => m.ClientServicesModule) },
      { path: 'sign-out', loadChildren: () => import('./pages/sign-out/sign-out.module').then(m => m.SignOutModule) },
      { path: 'lab-order', loadChildren: () => import('./pages/lab-order/lab-order.module').then(m => m.LabOrderModule) },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
